import React, { useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { CallbackPage, Login } from '../features/login';
import { selectUser, restoreFromCookie } from '../features/login/loginSlice';

import routes from './routes';
import roles from './roles';

import { NavBar } from '../common/components/NavBar';
import CookiesManager from '../common/utils/cookies';
import Container from '@mui/material/Container';

function App() {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { readCookie } = CookiesManager;

  var userRoutes = [];
  if (user.isAuth && user.role) {
    const { routesAllowed } = roles[user.role];
    if(routesAllowed[0] === "*"){
      userRoutes = routes;  
    } else {
      userRoutes = routes.filter((route) => routesAllowed.includes(route.path));
    }
  }

  useEffect(() => {
    const data = readCookie("userData");
    if (data) {
      dispatch(restoreFromCookie(data));
    } else {
      navigate("/login");
    }
  }, [dispatch, readCookie, navigate]);

  useEffect(() => {
    if (user.isAuth && userRoutes.length > 0) {
      // Only navigate if the current path is '/login' or not part of userRoutes
      const currentPath = location.pathname.slice(1); // remove leading '/'
      if (currentPath === 'login' || !userRoutes.some(route => route.path === currentPath)) {
        navigate("/" + userRoutes[0].path);
      }
    }
  }, [user, userRoutes, navigate, location]);

  if (!user.isAuth) {
    const currentPath = location.pathname.slice(1); // remove leading '/'
    if(currentPath === "callback") {
      return (
        <Container maxWidth={false} disableGutters sx={{ height: "95vh", width: "100vw", overflowY: "hidden" }}>
          <NavBar routes={userRoutes} />
          <Routes>
            <Route path="callback" element={<CallbackPage />} />
          </Routes>
        </Container>
      );
    } else {
      return (
        <Container maxWidth={false} disableGutters sx={{ height: "100vh" }}>
          <Routes>
            <Route path="login" element={<Login />} />
          </Routes>
        </Container>
      );
    }

  } else {
    return (
      <Container maxWidth={false} disableGutters sx={{ height: "95vh", width: "100vw", overflowY: "hidden" }}>
        <NavBar routes={userRoutes} />
        <Routes>
          {userRoutes.map((route) => {
            const { path, element: Element } = route;
            return <Route key={path} path={path} element={<Element />} />;
          })}
          <Route path="login" element={<Login />} />
        </Routes>
      </Container>
    );
  }
}

export default App;
